export const culture = {
    locale: "pt-BR",
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    dayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sá'],
    dateFormat: 'dd/mm/yy',
    datePlaceholder: 'dd/mm/yyyy',
    weekHeader: 'Sem',
    firstDay: 0,
    monthDayFormat: 'dd/mm',
    shortFormat: "d M",
    mediumFormat: "d M y",
    mediumFullYearFormat: "d M, yy",
    monthShortFormat: "M yy",
    yearFormat: "yy",
    FullFormat: "dd M, yy",
    LongTimeFormat: 'h:mm:ss TT',
    shortTimeFormat: 'h:mm TT',
    decimalSeparator: ",",
    currencyDecimalSeparator: ',',
    currencyGroupSeparator: '.',
    moneyWithCurrencyFormat: "{v} {c}",
    from: 'De',
    by: 'Por',
    fromFormat: 'De {0}',
    byFormat: 'Por {0}'
};

export const datepicker = {
    ...culture,
    closeText: 'Feito',
    prevText: 'Anterior',
    nextText: 'Próximo',
    currentText: 'Hoje',
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
};
